import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import Select from "react-select";
import axios from "axios";
import * as $ from "jquery";
import "bootstrap";

export default function Addbooking(props) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [items, setitems] = useState({
    UnitId: "",
    bookby: "",
    bookingtype: "",
    MethodId: "",
    Mettype: "",
    ShiftId: "",
    AgentId: "",
    CustomerId: "",
    bookingdate: "",
    Amount: 0,
    company_id: "",
    note: "",
    Beforediscount: 0,
    type: "",
    userid: 0,
    receipt: "",
    Samount: 0,
    Damount: 0,
    per: "",
    trans: "",
    food: "",
    croc: "",
    Disnote: "",
    adv: 0,
    holdbook: "",
    ismanagementbooking: false,
  });
  const [customer, setcustomer] = useState({
    NoOfMembers: "",
    Name: "",
    Address: "",
    Phone: "",
    Email: "",
    alternet_phone: "",
    company_name: "",
    company_Phone: "",
    company_Address: "",
    company_id: "",
    cnic: "",
  });
  const [addunit, setunit] = useState([]);
  const [addbtype, setbtype] = useState([]);
  const [addshift, setshift] = useState([]);
  const [unitvalue, setunitvalue] = useState();
  const [btypevalue, setbtypevalue] = useState();
  const [shiftvalue, setshiftvalue] = useState();
  const [typevalue, settypevalue] = useState();
  const [oldvalue, setoldvalue] = useState({ old: 0 });
  const [oldvaluesf, setoldvaluesf] = useState({ oldsf: 0 });
  const [type, settype] = useState([
    { label: "Corporate", value: "1" },
    { label: "Family", value: "2" },
    { label: "Edu. Institute", value: "3" },
    { label: "Friend", value: "5" },
  ]);
  const [Mettypevalue, setMettypevalue] = useState();
  const [Mettype, setMettype] = useState([
    { label: "Cash", value: "1" },
    { label: "Bank", value: "2" },
  ]);
  const [addMet, setMet] = useState([]);
  const [Metvalue, setMetvalue] = useState();
  const [addbook, setbook] = useState([]);
  const [bookvalue, setbookvalue] = useState();

  useEffect(() => {
    fetchUnitdata();
    fetchbtypedata();
    fetchShiftdata(1);
    fetchUserdata();
  }, []);
  useEffect(() => {
    if (props.date) {
      setitems({ ...items, bookingdate: props.date });
    }
  }, [props.date]);

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 4) {
      return digits;
    } else if (digits.length <= 11) {
      return `${digits.slice(0, 4)} ${digits.slice(4)}`;
    } else {
      return `${digits.slice(0, 4)} ${digits.slice(4, 11)}`;
    }
  };

  const handlePhoneInput = (e) => {
    const { name, value } = e.target;
    const formattedValue = formatPhoneNumber(value);
    setcustomer({ ...customer, [name]: formattedValue });
  };

  async function fetchUnitdata() {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "FramUnit/GetFramUnits?companyid=" +
      props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
      units.push({ value: u.unitId, label: u.unitName });
    });
    setunit(units);
  }

  async function fetchUserdata() {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "User/GetUsers?companyid=" +
      props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
      units.push({ value: u.id, label: u.f_name + " " + u.l_name });
    });
    setbook(units);
  }

  async function fetchbtypedata() {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "FramUnit/GetBookingtypes?companyid=" +
      props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
      units.push({ value: u.id, label: u.val });
    });
    setbtype(units);
  }
  async function Unitamount(shiftid, unitid, day) {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "FramUnit/GetFramUnitshifts?shiftid=" +
      shiftid +
      "&unitid=" +
      unitid +
      "&day=" +
      day +
      "&companyid=" +
      props.companyid;
    let res = await axios.get(Uniturl);
    setoldvaluesf({ ...oldvaluesf, oldsf: shiftid });
    setitems({ ...items, Samount: res.data.amount, Damount: res.data.amount });

    setoldvalue({ ...oldvalue, old: res.data.amount });
    return res.data.amount;
  }
  async function fetchShiftdata(unitid) {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "Shift/GetShiftunit?companyid=" +
      props.companyid +
      "&unitid=" +
      unitid;
    let response = await axios.get(Uniturl);
    var data = [];
    response.data.map((u) => {
      data.push({ value: u.shiftId, label: u.shiftName });
    });
    setshift(data);
  }

  const setunitvalues = (e) => {};
  const setbtypevalues = (e) => {};
  const setshiftvalues = (e) => {
    const date = new Date(items.bookingdate.toString());

    Unitamount(e.value, items.UnitId, date.getDay());
  };
  const setMettypevalues = (e) => {
    Unitamountss(e.value);
  };
  async function Unitamountss(shiftid) {
    const Uniturl =
      process.env.REACT_APP_APIURL +
      "payment/GetMethod?shiftid=" +
      shiftid +
      "&companyid=" +
      props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
      units.push({ value: u.id, label: u.title });
    });
    setMet(units);

    return "";
  }
  const settypevalues = (e) => {
    if (e.value == 1) {
      $("#Cor").css("display", "flex");
      $("#Cus").css("display", "flex");
    } else if (e.value == 2) {
      $("#Cor").css("display", "none");
      $("#Cus").css("display", "flex");
    } else if (e.value == 3) {
      $("#Cor").css("display", "none");
      $("#Cus").css("display", "flex");
    } else if (e.value == 4) {
      $("#Cor").css("display", "none");
      $("#Cus").css("display", "flex");
    } else if (e.value == 5) {
      $("#Cor").css("display", "none");
      $("#Cus").css("display", "flex");
    }
  };

  const handleInputCusomter = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setcustomer({ ...customer, [name]: value });
  };

  const handleInputBooking = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name == "per") {
      if (e.target.checked) {
        setitems({ ...items, [name]: value });
      } else {
        setitems({ ...items, [name]: "" });
      }
    } else if (name == "trans") {
      if (e.target.checked) {
        setitems({ ...items, [name]: value });
      } else {
        setitems({ ...items, [name]: "" });
      }
    } else if (name == "food") {
      if (e.target.checked) {
        setitems({ ...items, [name]: value });
      } else {
        setitems({ ...items, [name]: "" });
      }
    } else if (name == "croc") {
      if (e.target.checked) {
        setitems({ ...items, [name]: value });
      } else {
        setitems({ ...items, [name]: "" });
      }
    } else {
      setitems({ ...items, [name]: value });
    }
  };
  const handletextChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setitems({
      ...items,
      [name]: value,
      Damount: items.Samount - value,
      Samount: oldvalue.old,
      Amount: oldvalue.old,
      Beforediscount: oldvalue.old,
    });
  };
  const handleInputApply = (e) => {
    setitems({ ...items, Samount: oldvalue.old });
    setitems({ ...items, Amount: oldvalue.old });
    setitems({ ...items, Beforediscount: oldvalue.old });
    if (items.per == "per") {
      var dis = items.Samount * (items.discount / 100);
      setitems({ ...items, Damount: items.Samount - dis });
    } else {
      setitems({ ...items, Damount: items.Samount - items.discount });
    }
  };

  const refresh = () => {
    setitems({
      UnitId: "",
      bookby: "",
      bookingtype: "",
      MethodId: "",
      Mettype: "",
      ShiftId: "",
      AgentId: "",
      CustomerId: "",
      bookingdate: "",
      bookingamount: "",
      Amount: 0,
      discount: "",
      note: "",
      Beforediscount: 0,
      type: "",
      userid: 0,
      receipt: "",
      Samount: 0,
      Damount: 0,
      per: "",
      trans: "",
      food: "",
      croc: "",
      Disnote: "",
      adv: 0,
      holdbook: "",
      ismanagementbooking: false,
    });
    setcustomer({
      NoOfMembers: "",
      Name: "",
      Address: "",
      Phone: "",
      Email: "",
      alternet_phone: "",
      company_name: "",
      company_Phone: "",
      company_Address: "",
      cnic: "",
    });
    setunitvalue(null);
    setbtypevalue(null);
    setshiftvalue(null);
    settypevalue(null);
  };
  const Customersavemethod = async (data) => {
    return new Promise((resolve, reject) => {
      const url = process.env.REACT_APP_APIURL + "Customer/AddCustomer";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then(async (res) => {
          if (res.status == 200) {
            var json = await res.json();
            console.log(json);
            resolve(json);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  const setshiftvaluess = (e) => {};
  const BookingSaveData = async (booking) => {
    const url = process.env.REACT_APP_APIURL + "Booking/AddBooking";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(booking),
    })
      .then(async (res) => {
        if (res.status == 200) {
          debugger;
          if (booking.holdbook == "book") {
            swal({
              title: "Saved Successfully",
              icon: "success",
            });
          } else {
            swal({
              title:
                "Reservation Saved Successfully! If you not change the type from hold to book in next 3 days so it will automatically cancel",
              icon: "success",
            });
          }

          return true;
        } else {
          swal({ title: "Failed :(", icon: "error" });
          return false;
        }
      })
      .catch((error) => {
        swal({
          title: "Failed :(",
          text: error,
          icon: "error",
        });
        console.log(error);
      });
  };
  function handleclick(name) {
    debugger;
    refresh();
    modelOut();
  }
  function modelOut() {
    $("#myModal").modal("hide");
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    const submitButton = e.target.querySelector('button[type="submit"]');
    submitButton.disabled = true;
    submitButton.innerHTML =
      '<section><span class="loader-5"> </span></section>';

    try {
      var data = {};

      if (e.nativeEvent.submitter.id === "book") {
        data.holdbook = "book";
      } else if (e.nativeEvent.submitter.id === "hold") {
        data.holdbook = "hold";
      } else {
        refresh();
        return false;
      }

      const sanitizedCustomer = {
        ...customer,
        Phone: customer.Phone.replace(/\s+/g, ""),
        alternet_phone: customer.alternet_phone.replace(/\s+/g, ""),
        company_Phone: customer.company_Phone.replace(/\s+/g, ""),
      };

      if (items.UnitId === "") {
        swal({
          title: "Unit Required!",
          icon: "error",
        });
        return;
      }
      if (oldvaluesf.oldsf === "") {
        swal({
          title: "Shift Required!",
          icon: "error",
        });
        return;
      }

      if (!sanitizedCustomer.Phone || sanitizedCustomer.Phone.length !== 11) {
        swal({
          title: "Invalid Phone Number!",
          text: "Phone number must be in the format XXXX XXXXXXX.",
          icon: "error",
        });
        return;
      }

      if (!sanitizedCustomer.cnic || sanitizedCustomer.cnic.length !== 13) {
        swal({
          title: "Invalid CNIC!",
          text: "CNIC must be 13 digits long.",
          icon: "error",
        });
        return;
      }

      data.UnitId = items.UnitId;
      data.typeid = items.bookingtype;
      data.ShiftId = oldvaluesf.oldsf;
      data.Amount = items.Damount;
      if (items.AgentId) {
        data.AgentId = items.AgentId;
      }

      data.bookingdate = items.bookingdate;
      data.discount = items.discount;
      data.note = items.note;
      if (items.type === "" || items.type === 0) {
        swal({
          title: "Event Type Required!",
          icon: "error",
        });
        return;
      }
      if (items.MethodId === "" || items.MethodId === 0) {
        swal({
          title: "Payment Method Required!",
          icon: "error",
        });
        return;
      }
      if (items.bookby === "" || items.bookby === 0) {
        swal({
          title: "Booked By Required!",
          icon: "error",
        });
        return;
      }
      data.type = items.type;
      data.userid = localStorage.getItem("userid");
      data.receipt = items.receipt;
      data.Beforediscount = data.Amount;
      data.bookedby = items.bookby;
      data.Method_ID = items.MethodId;
      data.Samount = items.Samount;
      data.Damount = items.Damount;
      data.per = items.per;
      data.trans = items.trans;
      data.food = items.food;
      data.croc = items.croc;
      data.Disnote = items.Disnote;
      data.adv = items.adv;
      data.ismanagementbooking = items.ismanagementbooking;
      data.Company_id = props.companyid;

      const res = await fetch(
        process.env.REACT_APP_APIURL +
          "Booking/CheckBooking?companyid=" +
          props.companyid,
        {
          method: "POST",
          headers: {
            Accept: "json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const json = await res.json();

      if (json !== 0) {
        sanitizedCustomer.company_id = props.companyid;

        try {
          const id = await Customersavemethod(sanitizedCustomer);

          data.CustomerId = id;
          data.company_id = props.companyid;

          if (BookingSaveData(data)) {
            props.savingStatus(true);
          } else {
            props.savingStatus(false);
          }
          refresh();
        } catch (err) {
          console.log(err);
          swal({
            title: "Failed :(",
            text: err,
            icon: "error",
          });
        }
      } else {
        swal({
          title: ":(",
          text: "Shift already booked",
        });
        return false;
      }
    } catch (error) {
      console.log(error);
      swal({
        title: "Failed :(",
        text: error,
        icon: "error",
      });
    } finally {
      submitButton.disabled = false;
      submitButton.innerHTML = "Book";
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h3 className="me-auto mb-2 mt-5 text-center mx-auto">
              Add Booking
            </h3>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <form onSubmit={handleSubmit}>
                <div className="row flex-column align-items-center">
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      autoComplete="off"
                      className="form-control"
                      value={items.bookingdate}
                      id="mdate"
                      onChange={(e) => {
                        setitems({ ...items, bookingdate: e.target.value });
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label htmlFor="unit_name" className="form-label">
                      Unit
                    </label>
                    <Select
                      name="unit"
                      value={unitvalue}
                      options={addunit}
                      onChange={(e) => {
                        setunitvalues(e);
                        setitems({ ...items, UnitId: e.value });
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Shift</label>
                    <Select
                      options={addshift}
                      value={shiftvalue}
                      id="shift"
                      onChange={(e) => {
                        setshiftvalues(e);
                        setitems({ ...items, ShiftId: e.value });
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Amount</label>
                    <input
                      type="text"
                      autoComplete="off"
                      id="Amount"
                      name="note"
                      value={items.Samount}
                      onChange={handleInputBooking}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Discount</label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="discount"
                      value={items.discount}
                      onChange={handletextChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3 col-sm-6" hidden>
                    <label htmlFor="timepicker2">Discount Type Apply</label>
                    <div className="checkbox-group" id="checkboxes">
                      <ul>
                        <li>
                          <input
                            type="checkbox"
                            id="per"
                            name="per"
                            value="per"
                            onChange={handleInputBooking}
                          />
                          <label htmlFor="per">%</label>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="btn btn-success btn-xs"
                            onClick={handleInputApply}
                          >
                            Apply
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Discounted Price</label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="Damount"
                      value={items.Damount}
                      onChange={handleInputBooking}
                      className="form-control"
                      readOnly
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Discount Justify</label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="Disnote"
                      value={items.Disnote}
                      onChange={handleInputBooking}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Advance Payment</label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="adv"
                      value={items.adv}
                      onChange={handleInputBooking}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label htmlFor="booking_id" className="form-label">
                      Payment Method
                    </label>
                    <Select
                      value={Mettypevalue}
                      options={Mettype}
                      onChange={(e) => {
                        setMettypevalues(e);
                        setitems({ ...items, Mettype: e.value });
                      }}
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label className="form-label">Payment Title</label>
                    <Select
                      options={addMet}
                      value={Metvalue}
                      id="title"
                      onChange={(e) => {
                        setshiftvaluess(e);
                        setitems({ ...items, MethodId: e.value });
                      }}
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label htmlFor="bookingtype" className="form-label">
                      Booking Type
                    </label>
                    <Select
                      name="bookingtype"
                      value={btypevalue}
                      options={addbtype}
                      onChange={(e) => {
                        setbtypevalues(e);
                        setitems({ ...items, bookingtype: e.value });
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label htmlFor="bookedby" className="form-label">
                      Booked By
                    </label>
                    <Select
                      name="bookedby"
                      value={bookvalue}
                      options={addbook}
                      onChange={(e) => {
                        setunitvalues(e);
                        setitems({ ...items, bookby: e.value });
                      }}
                      required
                    />
                  </div>
                  <div className="mb-3 col-sm-6">
                    <label htmlFor="form-label" className="form-label">
                      Event Type
                    </label>
                    <Select
                      value={typevalue}
                      options={type}
                      onChange={(e) => {
                        settypevalues(e);
                        setitems({ ...items, type: e.value });
                      }}
                    />
                  </div>
                  <div className="mb-3 col-sm-6" hidden>
                    <label htmlFor="timepicker2">Other Services</label>
                    <div className="checkbox-group" id="checkboxes">
                      <ul>
                        <li>
                          <input
                            type="checkbox"
                            id="trans"
                            name="trans"
                            value="trans"
                            onChange={handleInputBooking}
                          />
                          <label htmlFor="trans">
                            <i className="fa fa-subway"></i>
                          </label>
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="food"
                            name="food"
                            value="food"
                            onChange={handleInputBooking}
                          />
                          <label htmlFor="food">
                            <i className="fas fa-pizza-slice"></i>
                          </label>
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="croc"
                            name="croc"
                            value="croc"
                            onChange={handleInputBooking}
                          />
                          <label htmlFor="croc">
                            <i className="fas fa-utensils"></i>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="w-100 pt-4 pb-2 mb-4 mt-3" style={{ backgroundColor: '#fff7ed', borderRadius: '12px', border: '1px solid #fed7aa' }}>
                    <div id="Cus" className="w-100" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="mb-3 col-sm-6">
                      <label className="form-label">Customer name</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="Name"
                        value={customer.Name}
                        onChange={handleInputCusomter}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="mb-3 col-sm-6">
                      <label className="form-label">No of members</label>
                      <input
                        type="number"
                        autoComplete="off"
                        name="NoOfMembers"
                        value={customer.NoOfMembers}
                        onChange={handleInputCusomter}
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="mb-3 col-sm-6 col-lg-6">
                      <label className="form-label">Primary Phone</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="Phone"
                        value={customer.Phone}
                        onChange={handlePhoneInput}
                        className="form-control"
                        maxLength="12"
                        placeholder="XXXX XXXXXXX"
                        required
                      />
                    </div>
                    <div className="mb-3 col-sm-6 col-lg-6" hidden>
                      <label className="form-label">Alternet Phone</label>
                      <input
                        type="phone"
                        autoComplete="off"
                        name="alternet_phone"
                        value={customer.alternet_phone}
                        onChange={handlePhoneInput}
                        className="form-control"
                        maxLength="12"
                        placeholder="XXXX XXXXXXX"
                      />
                    </div>
                    <div className="mb-3 col-sm-6 col-lg-6 " hidden>
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        autoComplete="off"
                        name="Email"
                        value={customer.Email}
                        onChange={handleInputCusomter}
                        className="form-control"
                      />
                    </div>

                    <div className="mb-3 col-sm-6 col-lg-6">
                      <label className="form-label">CNIC</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="cnic"
                        value={customer.cnic}
                        onChange={(e) =>
                          setcustomer({
                            ...customer,
                            cnic: e.target.value.replace(/\D/g, ""),
                          })
                        }
                        className="form-control"
                        maxLength="13"
                        placeholder="Enter 13-digit CNIC"
                        required
                      />
                    </div>
                    <div className="mb-3 col-sm-6 col-lg-12" hidden>
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="Address"
                        value={customer.Address}
                        onChange={handleInputCusomter}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div id="Cor" className="w-100" style={{ display: 'none', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="mb-3 col-sm-6 col-lg-6">
                      <label className="form-label">Company Name</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="company_name"
                        value={customer.company_name}
                        onChange={handleInputCusomter}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-3 col-sm-6 col-lg-6">
                      <label className="form-label">Company Phone</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="company_Phone"
                        value={customer.company_Phone}
                        onChange={handlePhoneInput}
                        className="form-control"
                        maxLength="12"
                        placeholder="XXXX XXXXXXX"
                      />
                    </div>
                    <div className="mb-3 col-sm-6 col-lg-6">
                      <label className="form-label">Company Address</label>
                      <input
                        type="text"
                        autoComplete="off"
                        name="company_Address"
                        value={customer.company_Address}
                        onChange={handleInputCusomter}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                  <div className="mb-3 col-sm-6 col-lg-6">
                    <label className="form-label">Notes</label>
                    <textarea
                      name="note"
                      value={items.note}
                      onChange={handleInputBooking}
                      className="form-control"
                      rows="6"
                      style={{  minHeight: '100px',resize: 'vertical' }}
                    ></textarea>
                    
                    <div className="form-check mt-3 d-flex align-items-center" style={{ paddingLeft: '0' }}>
                      <input
                        type="checkbox"
                        className="form-check-input m-0 me-2"
                        id="ismanagementbooking"
                        name="ismanagementbooking"
                        checked={items.ismanagementbooking}
                        onChange={(e) => setitems({ ...items, ismanagementbooking: e.target.checked })}
                        style={{ cursor: 'pointer', width: '24px', height: '24px', flexShrink: 0 }}
                      />
                      <label className="form-check-label mb-0 d-flex align-items-center" htmlFor="ismanagementbooking" style={{ cursor: 'pointer', fontWeight: '600', color: '#334155', fontSize: '16px', paddingTop: '2px' }}>
                        Is Management Booking
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          <i 
                            className="fas fa-info-circle ms-2" 
                            style={{ color: '#94a3b8', fontSize: '16px', zIndex: 10 }}
                            onClick={(e) => { e.preventDefault(); setShowTooltip(!showTooltip); }}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          ></i>
                          {showTooltip && (
                            <div style={{
                              position: 'absolute',
                              bottom: '100%',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              marginBottom: '8px',
                              backgroundColor: '#1e293b',
                              color: 'white',
                              padding: '8px 12px',
                              borderRadius: '6px',
                              fontSize: '13px',
                              fontWeight: '500',
                              whiteSpace: 'nowrap',
                              zIndex: 1000,
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                            }}>
                              Check this box if the booking is internal/management related.<br />Leave unchecked for regular customer bookings.
                              <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                borderWidth: '6px',
                                borderStyle: 'solid',
                                borderColor: '#1e293b transparent transparent transparent'
                              }}></div>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 col-sm-6" hidden>
                    <label className="form-label">receipt</label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="receipt"
                      value={items.receipt}
                      onChange={handleInputBooking}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row justify-content-center inner-btn">
                  <div>
                    <button type="submit" className="btn btn-primary" id="book">
                      Book
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      id="Cancel"
                      onClick={() => handleclick("cancel")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
